import { render } from "./AddonAmendmentsCard.vue?vue&type=template&id=546b2bf4"
import script from "./AddonAmendmentsCard.vue?vue&type=script&lang=js"
export * from "./AddonAmendmentsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__